export default [
    {
        index: 0,
        custom: false,
        key: "id",
        type: "field",
    },
    {
        index: 1,
        custom: true,
        key: "plaque",
        type: "field",
    },
    {
        index: 2,
        custom: true,
        key: "name",
        type: "field",
    },
    {
        index: 3,
        custom: true,
        key: "kmdepart",
        type: "field",
    },
    {
        index: 4,
        custom: true,
        key: "kmretour",
        type: "field",
    },
    {
        index: 5,
        custom: true,
        expression: {
            value: "{created_at}",
            type: "date",
            format: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            },
        },
        key: "",
        type: "field",
    },
    {
        index: 6,
        custom: true,
        option: [
            {
                text: "Editer",
                icon: "fa fa-eye",
                action: "click",
                parameter: "ref",
                key: "id",
                type: "field",
                onclick : ()=>alert('salut la team'),

            },
        ],
        key: "",
        type: "option",
    },
]
